/**
 * Created by wangjianwen on 2017/10/16.
 */
import * as func from '../function';
export  default{
    setExamRegId(states, examRegId){
        states.examRegId = examRegId;
        func.func.set('examRegId',examRegId);
    },
    setExamRegInfo(states, examRegInfo){
        states.examRegInfo = examRegInfo;
        func.func.set('examRegInfo',examRegInfo);
    },
    setExamRegInfoItem(states, subExamRegInfo){
        let examRegInfo = states.examRegInfo;
        if (!examRegInfo) {
            examRegInfo = {}
        }
        for (let key in subExamRegInfo) {
            examRegInfo[key] = subExamRegInfo[key]
        }
        states.examRegInfo = examRegInfo;
        func.func.set('examRegInfo',examRegInfo);
    },
    setBatchId(states, batchId){
        states.batchId = batchId;
        func.func.set('batchId',batchId);
    },
    setPromiseState(states, promiseState){
        states.promiseState = promiseState;
        func.func.set('promiseState',promiseState);
    },
    setBackOrNextStep(states, backOrNextStep){
        states.backOrNextStep = backOrNextStep;
        func.func.set('backOrNextStep',backOrNextStep);
    },
}